let t,r=256;function n(n=11){if(!t||r+n>512){t="",r=0;for(let r=0;r<256;r++)t+=(256+256*Math.random()|0).toString(16).substring(1)}return t.substring(r,r+++n)}export{n as uid};
